import { jsxs as b, jsx as m } from "react/jsx-runtime";
import { forwardRef as p, useContext as I, useRef as L, useImperativeHandle as R, useEffect as C } from "react";
import E from "../builders-icons/dist/systems/search.js";
import { useTracking as N, useReqireLabel as S, getLabel as j } from "../utils.js";
import { InputGroupContext as B } from "../input-group/utils.js";
import O from "clsx";
import i from "./input.module.css.js";
const W = p(function({
  classNameWrapper: h,
  hidden: f,
  invalid: l,
  prefix: u,
  size: s,
  style: v,
  suffix: k,
  wrapperProps: c,
  ...e
}, y) {
  e.tracking === void 0 && (e.tracking = !0), I(B)(e);
  const a = L(null), t = e.type === "checkbox" || e.type === "radio", o = e.type === "switch", g = O(i.wrapper, h, c == null ? void 0 : c.className, {
    [i[`${e.internal}`]]: e.internal,
    [i.htmlSize]: s,
    [i.isBoolean]: t || o,
    [i.isDisabled]: e.disabled,
    [i.isInvalid]: l,
    [i.isReadOnly]: !e.role && e.readOnly,
    // add styling if readonly and no role (f.ex. combobox when selecting options)
    [i.isSwitch]: o
  }), r = N(e.tracking);
  return R(y, () => a.current), S(a), C(() => {
    const n = a.current, d = () => {
      const x = n != null && n.checked ? "checked" : "unchecked";
      r({
        eventCategory: "input",
        eventAction: t ? x : "change",
        eventLabel: j(n)
      });
    };
    return n == null || n.addEventListener("change", d), () => n == null ? void 0 : n.removeEventListener("change", d);
  }, [r, t]), /* @__PURE__ */ b("span", { ...c, className: g, hidden: f, children: [
    t || o || u || e.type === "search" && /* @__PURE__ */ m(E, {}),
    /* @__PURE__ */ m(
      "input",
      {
        ...e,
        tracking: void 0,
        internal: void 0,
        "aria-invalid": e["aria-invalid"] || l || void 0,
        "data-internal-small": e.internal === "small" || void 0,
        ref: a,
        style: { ...v, "--size": s },
        type: e.type === "switch" ? "checkbox" : e.type
      }
    ),
    t || o || k
  ] });
});
export {
  W as Input
};
//# sourceMappingURL=input.js.map
